var map = {
	"./Bardzo_duze_150.json": 3197,
	"./Duze_50_150.json": 8528,
	"./Layer_07_09.11.json": 4642,
	"./Layer_24_25_26.10.2023.json": 1687,
	"./Layer_6MW_wszystkie.json": 3398,
	"./Mega_Wiochy.json": 2403,
	"./ROZJAZDOWKI.json": 5733,
	"./Rozjazdowki_Ma_e_5_15.json": 403,
	"./Srednie_15_50.json": 6416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 570;